<template>
    <CieloLayout>
        <router-view />
    </CieloLayout>
</template>

<script>
const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
);

export default {
  components: {
    CieloLayout,
  },


};
</script>

<style lang="scss" scoped>
.loader {
  display: block;
  width: 70px;
  height: 70px;
}
</style>
